// extracted by mini-css-extract-plugin
export var inputContainer = "_ta-0";